enum RunsTableViewMode {
    ARCHIVED = 'archived',
    TEN_DAYS = '10-days',
    OPEN = 'open',
}

export default RunsTableViewMode;
